import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const CloseIcon = ({ onClick }) => (
  <Wrapper onClick={onClick}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#FFFFFF"
    >
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  </Wrapper>
);

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/icons/CloseIcon.js